import { CatHeading } from 'components/blocks-components';

export const ProductCardHeading = ({ title }) => {
  return (
    <CatHeading
      variant="title-sm"
      className="d-flex justify-content-between align-items-center px-0 pt-0 py-1 p-blg-3"
    >
      {title}
    </CatHeading>
  );
};
